import SwModal from './SwModal'
import SwInput from './SwInput'
import SwTable from './SwTable'
import SwButton from './SwButton'
import SwDropdown from './SwDropdown'
import SwCard from './SwCard'
import SwList from './SwList'
import SwWizard from './SwWizard'
import SwTextarea from './SwTextarea'
import SwPopup from './SwPopup'
import SwBadge from './SwBadge'
import SwFilterWrapper from './SwFilterWrapper'
import SwSwitch from './SwSwitch'
import SwFileInput from './SwFileInput'

export default {
  SwModal,
  SwInput,
  SwTable,
  SwButton,
  SwCard,
  SwList,
  SwWizard,
  SwTextarea,
  SwPopup,
  SwDropdown,
  SwBadge,
  SwFilterWrapper,
  SwSwitch,
  SwFileInput,
}
